import { ChangeDetectorRef, Component, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import {CdkDragDrop, moveItemInArray, transferArrayItem, CdkDropList} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-multiple-sorting-dialog',
  templateUrl: './multiple-sorting-dialog.component.html',
  styleUrls: ['./multiple-sorting-dialog.component.css']
})
export class MultipleSortingDialogComponent {
  @ViewChild(MatTable) table: any;
  allColumns: string[] = []; // Array of all available columns
  selectedColumns: { name: string, sortOrder: 'ASC' | 'DESC' }[] = []; // Array of selected columns
  dataSource!: MatTableDataSource<any>;
  bus_nm:any
  @Output() applySorting: EventEmitter<any> = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<MultipleSortingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { allColumns: string[] } ,
    @Inject(MAT_DIALOG_DATA) public displayedColumnsObj: { displayedColumnsObj: any },
    @Inject(MAT_DIALOG_DATA) public currentSortingCriteria: { currentSortingCriteria: any }
    // Inject allColumns from parent component currentSortingCriteria
  ) {
    // Initialize allColumns array with default values
    this.allColumns = data.allColumns;
    this.bus_nm=displayedColumnsObj.displayedColumnsObj
    if(currentSortingCriteria.currentSortingCriteria){
      this.dataSource=currentSortingCriteria.currentSortingCriteria
      console.log(this.dataSource);
      
    }
    

    console.log(this.bus_nm);
    
  }

  addColumn(columnName: string): void {
    if (!this.selectedColumns.some(col => col.name === columnName)) {
      this.selectedColumns.push({ name: columnName, sortOrder: 'ASC' });
      console.log(this.selectedColumns);
      this.updateDataSourceAndDetectChanges()
      
    }
  }
  updateDataSourceAndDetectChanges(): void {
    // Update your data source
    this.dataSource = new MatTableDataSource(this.selectedColumns);
  
    // Trigger change detection
    this.cdr.detectChanges();
  }

  removeColumn(columnName: string): void {
    this.selectedColumns = this.selectedColumns.filter(col => col.name !== columnName);
  }

  toggleSortOrder(columnName: string): void {
    const column = this.selectedColumns.find(col => col.name === columnName);
    if (column) {
      column.sortOrder = column.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    }
  }
  sortingCriteria:any
  apply(): void {
    // Filter selected columns and their sort order
    this.sortingCriteria=[]
    let preserveState=this.dataSource.data.filter(column => column.sortOrder !== null);
    this.sortingCriteria = this.dataSource.data.filter(column => column.sortOrder !== null);
    console.log(this.sortingCriteria);
    const order:any=this.sortingCriteria.map((column:any) => [column.name, column.sortOrder]);
    this.applySorting.emit({'order':order,'preserveState':preserveState}); // Assuming sortingCriteria is an array of strings
    this.dialogRef.close(); // Close the dialog
    
   
  }

  cancel(): void {
    this.dialogRef.close();
  }

  drop(event: any): void {
    console.log(event);
    
    const previousIndex = this.dataSource.data.findIndex(row => row === event.item.data);
    moveItemInArray(this.dataSource.data, previousIndex, event.currentIndex);
    this.dataSource.data = [...this.dataSource.data]; // Ensure that the data source reference changes
    this.table.renderRows(); // Manually trigger the rendering of rows
 
   // this.dataSource.renderRows()
   // this.dataSource.data = clonedeep(this.dataSource.data);
 
  }
}
